"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2929],{

/***/ 44795:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wallet.783192ea.svg","height":18,"width":18});

/***/ }),

/***/ 93356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_InputBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13970);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_CustomNumericFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25192);
/* harmony import */ var _utils_use_event_callback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88095);





const BaseAmountInput = (param)=>{
    let { inputProps , maxLimit , decimals =9 , debounceMilliseconds , ...props } = param;
    const onInputFocus = (0,_utils_use_event_callback__WEBPACK_IMPORTED_MODULE_3__/* .useEventCallback */ .$)((event)=>{
        if (Number(event.target.value) === 0) {
            event.target.select();
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        inputComponent: _components_base_CustomNumericFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        placeholder: "0",
        inputProps: {
            "aria-label": "0",
            className: "p-0 text-xl iw:text-[#000E0F] font-semibold",
            min: 0,
            ...inputProps || {},
            decimalScale: decimals,
            allowNegative: false,
            thousandSeparator: ",",
            inputMode: "decimal",
            maxLimit,
            debounceMilliseconds
        },
        onFocus: onInputFocus,
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(BaseAmountInput));


/***/ }),

/***/ 25192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90482);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57333);




const DEFAULT_MAX_LIMIT = 1e10 // 10,000,000,000
;
const CustomNumericFormat = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function NumericFormatCustom(props, ref) {
    const { onChange , maxLimit , value , debounceMilliseconds , ...other } = props;
    const [inputValue, setInputValue] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [focused, setFocused] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const timeoutId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!focused && (value || inputValue)) {
            setInputValue(value != null ? new decimal_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(Number(value)).toFixed() : "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        focused,
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, {
        ...other,
        value: inputValue,
        getInputRef: ref,
        onValueChange: (param, param1)=>{
            let { floatValue , value  } = param, { event ={}  } = param1;
            setInputValue(value);
            const params = {
                ...event,
                target: {
                    ...event.target,
                    name: props.name,
                    floatValue,
                    value
                }
            };
            if (debounceMilliseconds) {
                timeoutId.current && clearTimeout(timeoutId.current);
                timeoutId.current = setTimeout(()=>{
                    onChange === null || onChange === void 0 ? void 0 : onChange(params);
                }, debounceMilliseconds);
            } else {
                onChange === null || onChange === void 0 ? void 0 : onChange(params);
            }
        },
        thousandSeparator: true,
        valueIsNumericString: true,
        allowedDecimalSeparators: [
            ","
        ],
        isAllowed: (values)=>{
            const floatValue = values.floatValue || 0;
            return floatValue <= (maxLimit || DEFAULT_MAX_LIMIT);
        },
        onBlur: (event)=>{
            var _other_onBlur;
            setFocused(false);
            (_other_onBlur = other.onBlur) === null || _other_onBlur === void 0 ? void 0 : _other_onBlur.call(other, event);
        },
        onFocus: (event)=>{
            var _other_onFocus;
            setFocused(true);
            (_other_onFocus = other.onFocus) === null || _other_onFocus === void 0 ? void 0 : _other_onFocus.call(other, event);
        },
        inputMode: "decimal"
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (CustomNumericFormat);


/***/ }),

/***/ 64249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const IconNoData = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "mx-auto",
        width: 64,
        height: 41,
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            transform: "translate(0 1)",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                    fill: "#fff",
                    fillOpacity: 0.08,
                    cx: 32,
                    cy: 33,
                    rx: 32,
                    ry: 7
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    stroke: "#434343",
                    fillRule: "nonzero",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
                            fill: "#293547",
                            stroke: "#434343"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconNoData);


/***/ }),

/***/ 9943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const IconSearch = (param)=>{
    let { color ="#61667E" , width =24  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "cursor-pointer",
        width: width,
        height: width,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.8103 5.43515C8.91733 2.4401 13.5412 2.55947 16.4169 5.43515C19.1668 8.18502 19.3349 12.539 16.9212 15.485L21.1899 19.7541L20.1292 20.8147L15.8601 16.5461C12.9141 18.9597 8.56017 18.7916 5.8103 16.0418C2.93462 13.1661 2.7994 8.33753 5.8103 5.43515ZM15.3562 6.49581C13.0131 4.15267 9.2141 4.15267 6.87096 6.49581C4.52781 8.83896 4.52781 12.6379 6.87096 14.9811C9.2141 17.3242 13.0131 17.3242 15.3562 14.9811C17.6994 12.6379 17.6994 8.83896 15.3562 6.49581Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconSearch);


/***/ }),

/***/ 91094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_numeric__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14847);


/**
 * A wrapper of the {@link format} method from numeric utility.
 */ const NumericOutput = (param)=>{
    let { value , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (0,_utils_numeric__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(value, props)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NumericOutput);


/***/ }),

/***/ 71682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ TokenPickerRevampContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const initContext = {
    isOpenPicker: false,
    setIsOpenPicker: ()=>null
};
const TokenPickerRevampContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initContext);
const TokenPickerRevampProvider = (param)=>{
    let { children  } = param;
    const [isOpenPicker, setIsOpenPicker] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            isOpenPicker,
            setIsOpenPicker
        }), [
        isOpenPicker,
        setIsOpenPicker
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TokenPickerRevampContext.Provider, {
        value: value,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TokenPickerRevampProvider);


/***/ }),

/***/ 82734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ container_Container; },
  "Z": function() { return /* reexport */ TokenPickerRevamp_container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(80437);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-pagination.ts + 1 modules
var use_pagination = __webpack_require__(73949);
// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./src/components/base/TokenPicker/utils.ts
var utils = __webpack_require__(52385);
// EXTERNAL MODULE: ./src/components/base/TokenPickerRevamp/context.tsx
var context = __webpack_require__(71682);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-window/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__(52848);
// EXTERNAL MODULE: ./src/components/base/Button/index.tsx
var Button = __webpack_require__(10737);
// EXTERNAL MODULE: ./src/components/base/IconNoData.tsx
var IconNoData = __webpack_require__(64249);
// EXTERNAL MODULE: ./src/components/base/IconSearch.tsx
var IconSearch = __webpack_require__(9943);
// EXTERNAL MODULE: ./src/hooks/use-balances.ts
var use_balances = __webpack_require__(68203);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 2 modules
var useTrans = __webpack_require__(74069);
// EXTERNAL MODULE: ./src/utils/static-import-icon.tsx + 42 modules
var static_import_icon = __webpack_require__(61930);
// EXTERNAL MODULE: ./src/components/base/BaseDialog.tsx + 6 modules
var BaseDialog = __webpack_require__(57833);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/styles.tsx


const StyledInput = (0,styled/* default */.ZP)((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
        ...props
    }))(()=>({
        "&": {
            padding: "7px 8px",
            borderRadius: "8px",
            border: "1px solid #61667E",
            backgroundColor: "#2A3748",
            fontSize: "14px",
            lineHeight: "20px",
            transition: "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
        },
        "& .MuiInput-input": {
            padding: "0 0 0 8px"
        },
        "&:focus-within": {
            borderColor: "#388bfd",
            boxShadow: "rgb(12, 45, 107) 0px 0px 0px 3px"
        }
    }));

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WarningRounded.js
var WarningRounded = __webpack_require__(6775);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/base/AddressSpanWithCopyButton.tsx
var AddressSpanWithCopyButton = __webpack_require__(19185);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/TokenListItem/index.tsx







const TokenListItem = (param)=>{
    let { option , nickName , onClick , balance , balanceUsd  } = param;
    const theme = (0,useTheme/* default */.Z)();
    const isUnknownToken = option.type === "user" && option.tags && !option.tags.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: "w-full flex items-center max-w-full gap-x-2 bg-[#141A23] px-4 py-2 rounded-lg cursor-pointer hover:bg-[#141A23]/60",
        "data-testid": classnames_default()({
            ["token-picker-".concat(option.symbol)]: !nickName,
            ["token-picker-".concat(nickName, "-").concat(option.symbol)]: nickName
        }),
        onClick: ()=>onClick(option),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "w-[30px] h-[30px] min-w-[30px] relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: isUnknownToken ? "opacity-30" : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: option.logoURI || "",
                            alt: option.name,
                            width: 30,
                            height: 30,
                            className: "w-full h-full rounded-full object-cover"
                        })
                    }),
                    isUnknownToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "absolute right-0 bottom-0 text-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningRounded/* default */.Z, {
                            htmlColor: "#EB5757",
                            fontSize: "inherit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1,
                    minWidth: 0,
                    "& .token-symbol": {
                        color: theme.palette.mode === "light" ? "#586069" : "#ffffff"
                    },
                    "& .token-name": {
                        color: theme.palette.mode === "light" ? "#586069" : "#D0D1D8"
                    },
                    "& .token-address": {
                        color: theme.palette.mode === "light" ? "#586069" : "#D0D1D8"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: "5px",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base font-semibold token-symbol",
                                        children: option.displaySymbol
                                    }),
                                    isUnknownToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: "bg-[#1E2735] text-xs font-medium px-2 py-1 rounded select-none text-[#9CA3AE]",
                                        children: "Unknown"
                                    })
                                ]
                            }),
                            balance > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base font-semibold token-balance",
                                children: (0,numeric/* formatSafe */.g1)(balance, option.decimals)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressSpanWithCopyButton/* default */.Z, {
                                address: option.address
                            }),
                            balanceUsd > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-xs token-balance-usd",
                                children: [
                                    "$",
                                    (0,numeric/* format */.WU)(balanceUsd)
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const memoTokenListItem = /*#__PURE__*/ (0,react.memo)(TokenListItem);
memoTokenListItem.displayName = "TokenListItem";
/* harmony default export */ var TokenPickerRevamp_TokenListItem = (memoTokenListItem);

;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/TokenList/utils.ts

const styling = {
    itemSize: 66,
    itemGap: 4,
    itemPerView: 6
};
const listHeight = new decimal/* default */.Z(styling.itemSize).plus(styling.itemGap).times(styling.itemPerView).minus(styling.itemGap);
const calculateItemPositionTop = (index)=>{
    return new decimal/* default */.Z(index).times(styling.itemSize + styling.itemGap).minus(index ? styling.itemGap : 0).toNumber();
};
const clickAndOpenInNewTab = (url)=>{
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.click();
};
const handleClickHighlightMessage = (url, router)=>{
    try {
        if (url.startsWith("/")) {
            router.push(url);
        }
        if (/^(http|https):\/\//.test(url)) {
            const urlObj = new URL(url);
            const isSameSite = urlObj.origin === window.location.origin;
            if (isSameSite) {
                router.push(urlObj.pathname);
            } else {
                clickAndOpenInNewTab(url);
            }
        }
    } catch (err) {
    //
    }
};

;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/TokenList/container.tsx
/* eslint-disable react/prop-types */ 


















const Container = (param, ref)=>{
    let { options , height , maxHeight , onClickTokenItem , search ="" , nickName , onSearch , hasMoreTokens , loadMoreTokens , onClickClose , highlightMessages , slot  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { balances  } = (0,use_balances/* useBalances */.l)();
    const { data: rateData  } = (0,use_settings/* useRemitanoRate */.T)();
    const [openWarningDialog, setOpenWarningDialog] = (0,react.useState)(false);
    const [warningToken, setWarningToken] = (0,react.useState)(null);
    const onSelectToken = (0,react.useCallback)((option)=>{
        if (option.type === "user" && option.tags && !option.tags.length) {
            setOpenWarningDialog(true);
            setWarningToken(option);
        } else {
            onClickTokenItem(option);
        }
    }, [
        onClickTokenItem
    ]);
    const onClickUnderstand = (0,react.useCallback)(()=>{
        setOpenWarningDialog(false);
        if (warningToken) onClickTokenItem(warningToken);
    }, [
        onClickTokenItem,
        warningToken
    ]);
    const onItemsRendered = (0,react.useCallback)(async (param)=>{
        let { visibleStopIndex  } = param;
        if (hasMoreTokens && visibleStopIndex === options.length) {
            await loadMoreTokens();
        }
    }, [
        hasMoreTokens,
        loadMoreTokens,
        options
    ]);
    const childrenOfList = (0,react.useCallback)((param)=>{
        let { index , style  } = param;
        const opt = options[index];
        if (!opt) return null;
        const rateKey = opt.symbol.toUpperCase();
        const rate = rateData && rateData[rateKey] || 0;
        const balance = balances[opt.symbol] || 0;
        const balanceUsd = rate ? new decimal/* default */.Z(balance).mul(rate).toNumber() : 0;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full items-center justify-center overflow-hidden",
            style: {
                ...style,
                top: calculateItemPositionTop(index),
                height: styling.itemSize,
                marginTop: index ? styling.itemGap : 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPickerRevamp_TokenListItem, {
                option: opt,
                nickName: nickName,
                onClick: onSelectToken,
                balance: balance,
                balanceUsd: balanceUsd
            }, opt.symbol)
        }, opt.address);
    }, [
        options,
        onSelectToken,
        nickName,
        rateData,
        balances
    ]);
    const onClickHighlightMessages = (0,react.useCallback)(()=>{
        handleClickHighlightMessage(highlightMessages.url, router);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        highlightMessages.url
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            highlightMessages.markdown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                title: highlightMessages.url,
                onClick: onClickHighlightMessages,
                "data-testid": "highlight-messages",
                className: "px-6 py-4 pb-7 relative bottom-[-16px] flex items-start justify-center bg-[#FF6701] rounded-t-2xl gap-2 cursor-pointer underline select-none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.REPEAT */.u.REPEAT),
                        alt: "repeat",
                        width: 24,
                        className: "relative top-[-2px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        dangerouslySetInnerHTML: {
                            __html: highlightMessages.markdown
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "px-6 py-4 bg-[#141A23] sm:bg-[#1A2330] rounded-t-2xl relative",
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-xl font-bold",
                        children: trans.home.select_a_token
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {
                        className: "cursor-pointer",
                        onClick: onClickClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                ref: ref,
                className: "bg-[#1E2735] px-6 pt-2 pb-6 sm:rounded-b-2xl gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        fullWidth: false,
                        disableUnderline: true,
                        placeholder: trans.common.token_picker_filter_by,
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* default */.Z, {}),
                        className: "w-full",
                        value: search,
                        onChange: (evt)=>{
                            return onSearch === null || onSearch === void 0 ? void 0 : onSearch(evt.target.value);
                        },
                        "data-testid": "search-coins-input"
                    }),
                    slot,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        gap: 0.5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm font-bold opacity-[0.72]",
                                children: "RENEC tokens"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                gap: 0.5,
                                className: "overflow-auto",
                                sx: {
                                    maxHeight,
                                    height
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FixedSizeList */.t7, {
                                        className: "token-list",
                                        height: listHeight.toNumber(),
                                        width: "100%",
                                        itemCount: options.length + +hasMoreTokens,
                                        itemSize: listHeight.div(styling.itemPerView).toNumber(),
                                        onItemsRendered: onItemsRendered,
                                        children: childrenOfList
                                    }),
                                    options.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        alignItems: "center",
                                        className: "text-center absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNoData/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: "text-sm mt-2 text-[#B0B2BE]",
                                                children: trans.common.token_picker_no_tokens_found
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseDialog/* default */.Z, {
                "data-testid": "warning-unknown-dialog",
                title: trans.common.warning,
                body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    className: "justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/warning.png",
                            alt: "warning",
                            width: "95",
                            height: "94",
                            className: "mb-6"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "text-xl font-bold mb-4",
                            "data-testid": "warning-unknown-token-title",
                            children: trans.common.unknown_token
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "text-center",
                            "data-testid": "warning-unknown-token-content",
                            children: trans.common.warning_unknown_token_content
                        })
                    ]
                }),
                handleClose: ()=>setOpenWarningDialog(false),
                isOpened: openWarningDialog,
                isSmallPopup: true,
                button: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    display: "flex",
                    className: "w-full space-y-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            "data-testid": "warning-unknown-dialog-understand-btn",
                            variant: "primary",
                            size: "lg",
                            onClick: onClickUnderstand,
                            children: trans.common.i_understand
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            "data-testid": "warning-unknown-dialog-cancel-btn",
                            variant: "outlined",
                            size: "lg",
                            onClick: ()=>setOpenWarningDialog(false),
                            children: trans.common.cancel
                        })
                    ]
                }),
                useDrawerOnMobile: true
            })
        ]
    });
};
/* harmony default export */ var container = (/*#__PURE__*/(0,react.forwardRef)(Container));

;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/TokenList/index.tsx


// EXTERNAL MODULE: ./src/components/base/TokenPickerRevamp/view.tsx + 1 modules
var view = __webpack_require__(35177);
;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/container.tsx











const dialogClasses = {
    root: "max-w-[488px] sm:min-w-[488px] p-0 mx-auto outline-none absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
};
const container_Container = (param)=>{
    let { selectedToken: initSelectedToken , options: tokens , dataTestId , onChangeToken , nickName , slot , isDisplayActionView =true , isDisplayHighlightMessage =true  } = param;
    const theme = (0,useTheme/* default */.Z)();
    const { locale ="en"  } = (0,next_router.useRouter)();
    const { data: settingsData  } = (0,use_settings/* useSettings */.r)();
    const onChangeTokenRef = (0,react.useRef)(onChangeToken);
    onChangeTokenRef.current = onChangeToken // No need to care whether the outside uses memo or not
    ;
    const isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const { isOpenPicker , setIsOpenPicker  } = (0,react.useContext)(context/* TokenPickerRevampContext */.V);
    const [searchStr, setSearchStr] = (0,react.useState)("");
    const [selectedToken, setSelectedToken] = (0,react.useState)(initSelectedToken);
    const paginationParams = (0,react.useMemo)(()=>({
            queryKey: "tokens?keyword=".concat(searchStr.trim().toLowerCase()),
            loader: ()=>Promise.resolve([]),
            comparator: (x, y)=>x.address === y.address,
            initialData: tokens,
            itemsPerPage: 8
        }), [
        searchStr,
        tokens
    ]);
    const { hasMoreItems: hasMoreTokens , items: options , loadMore: loadMoreTokens , setItems: setAllTokens  } = (0,use_pagination/* default */.Z)(paginationParams);
    (0,react.useEffect)(()=>{
        const searchingOptions = !searchStr ? tokens : (0,utils/* searchTokenFromList */.N)(searchStr, options);
        setAllTokens(searchingOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tokens,
        searchStr
    ]);
    (0,react.useEffect)(()=>{
        setSelectedToken(initSelectedToken);
    }, [
        initSelectedToken
    ]);
    const handleToggleOpen = (0,react.useCallback)(()=>{
        setIsOpenPicker((o)=>!o);
        setSearchStr("");
    }, [
        setIsOpenPicker
    ]);
    const handleClickTokenItem = (0,react.useCallback)((token)=>{
        setSelectedToken(token);
        onChangeTokenRef.current(token);
        setIsOpenPicker(false);
    }, [
        onChangeTokenRef,
        setIsOpenPicker
    ]);
    const highlightMessages = (0,react.useMemo)(()=>{
        var _settingsData_highlight_messages;
        const emptyValue = {
            url: "",
            markdown: ""
        };
        if (!isDisplayHighlightMessage) return emptyValue;
        const returnedValue = (settingsData === null || settingsData === void 0 ? void 0 : (_settingsData_highlight_messages = settingsData.highlight_messages) === null || _settingsData_highlight_messages === void 0 ? void 0 : _settingsData_highlight_messages[locale]) || emptyValue;
        return returnedValue;
    }, [
        settingsData,
        locale,
        isDisplayHighlightMessage
    ]);
    const injectedProps = {
        nickName,
        options,
        search: searchStr,
        onSearch: setSearchStr,
        onClickTokenItem: handleClickTokenItem,
        hasMoreTokens,
        loadMoreTokens,
        onClickClose: handleToggleOpen,
        highlightMessages,
        slot
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isDisplayActionView && /*#__PURE__*/ (0,jsx_runtime.jsx)(view/* default */.Z, {
                dataTestId: dataTestId,
                token: selectedToken,
                onClick: handleToggleOpen
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                id: "token-picker",
                open: isOpenPicker,
                onClose: handleToggleOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                    classes: dialogClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
                        ...injectedProps,
                        maxHeight: "350px"
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                id: "token-picker",
                open: isOpenPicker,
                anchor: "bottom",
                onClose: handleToggleOpen,
                BackdropProps: {
                    className: "token-picker-backdrop"
                },
                sx: {
                    ".MuiPaper-elevation": {
                        backgroundColor: "transparent",
                        backgroundImage: "none"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
                    ...injectedProps,
                    height: highlightMessages.markdown ? "50vh" : "40vh"
                })
            })
        ]
    });
};
const ContainerWithProvider = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container_Container, {
            ...props
        })
    });
};
/* harmony default export */ var TokenPickerRevamp_container = (/*#__PURE__*/(0,react.memo)(ContainerWithProvider));

;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/index.tsx




/***/ }),

/***/ 35177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ view; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/svgs/arrow-down.svg
/* harmony default export */ var arrow_down = ({"src":"/_next/static/media/arrow-down.ac91f248.svg","height":12,"width":12});
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 2 modules
var useTrans = __webpack_require__(74069);
;// CONCATENATED MODULE: ./src/components/base/TokenPickerRevamp/view.tsx







const View = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { dataTestId , token , clickable =true , onClick  } = param;
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        ref: ref,
        "data-testid": dataTestId,
        onClick: clickable ? onClick : undefined,
        className: classnames_default()({
            "pl-1.5 pr-3 py-1.5": token,
            "bg-gradient-btn px-3 py-2": !token,
            "cursor-pointer": clickable
        }),
        bgcolor: token && "#1E2735",
        borderRadius: "8px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            className: "shrink-0 grow-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    children: token ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: "w-[24px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: token.logoURI,
                                    alt: token.name,
                                    className: "max-w-full rounded-full w-[24px] h-[24px] object-cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                "data-testid": "selected-token-symbol",
                                className: "text-sm select-none whitespace-nowrap leading-5 font-semibold px-1.5",
                                children: token.displaySymbol
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        "data-testid": "selected-token-symbol",
                        className: "text-sm select-none whitespace-nowrap leading-5 font-semibold pr-1",
                        children: trans.home.select_token
                    })
                }),
                clickable && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: arrow_down,
                    alt: "ArrowDownIcon",
                    className: "min-w-[12px] w-3 h-3",
                    "data-testid": "ExpandMoreIcon"
                })
            ]
        })
    });
});
View.displayName = "TokenPickerRevampView";
/* harmony default export */ var view = (View);


/***/ }),

/***/ 95060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/colord/index.mjs
var colord = __webpack_require__(16765);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/providers/liquidity-chart/index.tsx + 1 modules
var liquidity_chart = __webpack_require__(98042);
// EXTERNAL MODULE: ./src/providers/liquidity-chart/candle-utils.ts
var candle_utils = __webpack_require__(30646);
// EXTERNAL MODULE: ./src/utils/apis/tickers.ts + 1 modules
var tickers = __webpack_require__(86447);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
// EXTERNAL MODULE: ./src/components/base/NumericOutput.tsx
var NumericOutput = __webpack_require__(91094);
// EXTERNAL MODULE: ./src/components/chart/use-price-socket.tsx
var use_price_socket = __webpack_require__(24240);
// EXTERNAL MODULE: ./src/components/chart/utils.ts
var utils = __webpack_require__(80021);
;// CONCATENATED MODULE: ./src/components/chart/container.tsx













const SpanOption = (param)=>/*#__PURE__*/ {
    let { active , color , onClick , text  } = param;
    return (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        className: "px-2 py-1 rounded-lg cursor-pointer text-sm",
        "data-is-option-active": active,
        "data-testid": "span-option-".concat(text),
        onClick: onClick,
        sx: {
            "&": {
                ":hover": {
                    backgroundColor: (0,colord/* colord */.Vi)(color).invert().alpha(active ? 0.4 : 0.1).toRgbString()
                },
                backgroundColor: (0,colord/* colord */.Vi)(color).invert().alpha(active ? 0.4 : 0).toRgbString(),
                color: (0,colord/* colord */.Vi)(color).toRgbString()
            }
        },
        children: text
    });
};
const DefaultFormatterConfig = {
    desiredLength: 7
};
const Container = (param)=>{
    let { theme , timeFrame ="one_hour" , tokenA , tokenB , tz =0 , onCandleListUpdated , onPriceSentFromSocket , onTimeFrameChange  } = param;
    const queryClient = (0,es.useQueryClient)();
    const [element, setElement] = (0,react.useState)(null);
    const [span, setSpan] = (0,react.useState)(tickers/* tickerTimeFrameToSeconds */.zI[timeFrame]);
    const [tokenIn, tokenOut] = (0,react.useMemo)(()=>(0,utils/* orderTokensLikeBE */.gO)(tokenA, tokenB), [
        tokenA,
        tokenB
    ]);
    const [changeRate] = (0,react.useState)(0);
    const { lastMessage  } = (0,use_price_socket/* default */.Z)(tokenIn, tokenOut);
    const fetchCandleData = (0,react.useCallback)(async ()=>{
        const tickerData = await queryClient.fetchQuery((0,utils/* getQueryKeyTickers */._q)(tokenA, tokenB, span), ()=>(0,tickers/* getTickers */.ch)(tokenA, tokenB, tickers/* secondsToTickerTimeFrame */.Dg[span]), (0,utils/* getQueryOptionsTickers */.Tp)(span));
        return tickerData.candles;
    }, [
        queryClient,
        span,
        tokenA,
        tokenB
    ]);
    const { candles , updateLast  } = (0,liquidity_chart/* useLiquidityChart */.Zv)(element, {
        decimals: tokenB.decimals,
        formatterConfig: DefaultFormatterConfig,
        load: fetchCandleData,
        span,
        theme,
        tokenPair: candle_utils/* TokenPair.of */.o.of(tokenA.symbol, tokenB.symbol),
        tz
    });
    (0,react.useEffect)(()=>{
        if (!lastMessage) return;
        onPriceSentFromSocket === null || onPriceSentFromSocket === void 0 ? void 0 : onPriceSentFromSocket(lastMessage.data);
        const lastCandle = (0,utils/* mergeOrStartNewCandle */.PV)(candles[candles.length - 1], lastMessage.data, span);
        updateLast(lastCandle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lastMessage
    ]);
    (0,react.useEffect)(()=>{
        onCandleListUpdated === null || onCandleListUpdated === void 0 ? void 0 : onCandleListUpdated(candles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        candles
    ]);
    (0,react.useEffect)(()=>{
        setSpan(tickers/* tickerTimeFrameToSeconds */.zI[timeFrame]);
    }, [
        timeFrame
    ]);
    const changeRateColor = (0,react.useMemo)(()=>{
        return changeRate > 0 ? (theme === null || theme === void 0 ? void 0 : theme.candleRisingColor) || "#55F9C7" : changeRate < 0 ? (theme === null || theme === void 0 ? void 0 : theme.candleFallingColor) || "#FF6701" : "";
    }, [
        changeRate,
        theme === null || theme === void 0 ? void 0 : theme.candleFallingColor,
        theme === null || theme === void 0 ? void 0 : theme.candleRisingColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        className: "w-full h-full",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "font-bold text-xl",
                                "data-testid": "current-price",
                                style: {
                                    color: (theme === null || theme === void 0 ? void 0 : theme.headerTextColor) || (theme === null || theme === void 0 ? void 0 : theme.textColor) || "#FFFFFF"
                                },
                                children: candles.length ? (0,numeric/* format */.WU)(candles[candles.length - 1].close, tokenB.decimals) : "N/A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: classnames_default()("bg-opacity-10 rounded-lg px-2 py-1 text-sm", changeRate === 0 && "hidden"),
                                "data-testid": "current-change-rate",
                                style: {
                                    background: (0,colord/* colord */.Vi)(changeRateColor).alpha(0.1).toRgbString(),
                                    color: changeRateColor
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericOutput/* default */.Z, {
                                        decimals: 2,
                                        sign: true,
                                        value: changeRate * 100
                                    }),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        className: "select-none",
                        direction: "row",
                        spacing: 0.5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanOption, {
                                active: span === 3600,
                                color: (theme === null || theme === void 0 ? void 0 : theme.headerTextColor) || (theme === null || theme === void 0 ? void 0 : theme.textColor) || "#FFFFFF",
                                onClick: ()=>{
                                    return onTimeFrameChange === null || onTimeFrameChange === void 0 ? void 0 : onTimeFrameChange("one_hour");
                                },
                                text: "1H"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanOption, {
                                active: span === 14400,
                                color: (theme === null || theme === void 0 ? void 0 : theme.headerTextColor) || (theme === null || theme === void 0 ? void 0 : theme.textColor) || "#FFFFFF",
                                onClick: ()=>{
                                    return onTimeFrameChange === null || onTimeFrameChange === void 0 ? void 0 : onTimeFrameChange("four_hours");
                                },
                                text: "4H"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanOption, {
                                active: span === 86400,
                                color: (theme === null || theme === void 0 ? void 0 : theme.headerTextColor) || (theme === null || theme === void 0 ? void 0 : theme.textColor) || "#FFFFFF",
                                onClick: ()=>{
                                    return onTimeFrameChange === null || onTimeFrameChange === void 0 ? void 0 : onTimeFrameChange("twenty_four_hour");
                                },
                                text: "1D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpanOption, {
                                active: span === 604800,
                                color: (theme === null || theme === void 0 ? void 0 : theme.headerTextColor) || (theme === null || theme === void 0 ? void 0 : theme.textColor) || "#FFFFFF",
                                onClick: ()=>{
                                    return onTimeFrameChange === null || onTimeFrameChange === void 0 ? void 0 : onTimeFrameChange("one_week");
                                },
                                text: "1W"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: "flex-grow relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "absolute inset-0",
                    "data-testid": "chart",
                    ref: setElement
                })
            })
        ]
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/components/chart/index.ts



/***/ }),

/***/ 24240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _providers_cable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23458);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80021);



const usePriceSocket = (tokenA, tokenB)=>{
    const pairParams = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({
            pair: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .orderTokensLikeBE */ .gO)(tokenA, tokenB).map((param)=>{
                let { symbol  } = param;
                return symbol;
            }).join("/").toLowerCase()
        }), [
        tokenA,
        tokenB
    ]);
    const { lastMessage , ...rest } = (0,_providers_cable__WEBPACK_IMPORTED_MODULE_1__/* .useActionCableChannel */ .aM)("TradingView::Channel", pairParams);
    const formattedLastMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>lastMessage && {
            ...lastMessage,
            data: {
                price: lastMessage.data.p,
                time: new Date(lastMessage.data.t),
                volume: lastMessage.data.v
            }
        }, [
        lastMessage
    ]);
    return {
        ...rest,
        lastMessage: formattedLastMessage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePriceSocket);


/***/ }),

/***/ 80021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PV": function() { return /* binding */ mergeOrStartNewCandle; },
/* harmony export */   "Tp": function() { return /* binding */ getQueryOptionsTickers; },
/* harmony export */   "_q": function() { return /* binding */ getQueryKeyTickers; },
/* harmony export */   "gO": function() { return /* binding */ orderTokensLikeBE; }
/* harmony export */ });
/* harmony import */ var _providers_liquidity_chart_candle_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30646);
/* harmony import */ var _limit_order_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65992);


const mergeOrStartNewCandle = (lastCandle, newData, span)=>{
    const clampedStartTime = _providers_liquidity_chart_candle_utils__WEBPACK_IMPORTED_MODULE_0__/* .CandleSequence.clampStartTimeBySpan */ .B.clampStartTimeBySpan(newData.time, span);
    if (lastCandle && lastCandle.startTime.getTime() === clampedStartTime.getTime()) {
        return {
            ...lastCandle,
            close: newData.price,
            low: Math.min(lastCandle.low, newData.price),
            high: Math.max(lastCandle.high, newData.price),
            volume: newData.volume
        };
    } else {
        return {
            startTime: clampedStartTime,
            span,
            open: newData.price,
            close: newData.price,
            low: newData.price,
            high: newData.price,
            volume: newData.volume
        };
    }
};
/**
 * Replicates backend logic of sorting a token pair.
 *
 * @returns `[base, quote]`
 *
 * @see https://github.com/renec-chain/renechub/blob/e10f8fca45cf006186de721d8ccd76ea6375266a/app/helpers/nemoswap/market_price_tracking_helper.rb
 */ const orderTokensLikeBE = (tokenA, tokenB)=>{
    const [baseToken, quoteToken] = [
        tokenA,
        tokenB
    ].sort((a, b)=>a.symbol.toLowerCase().localeCompare(b.symbol.toLowerCase()));
    return (0,_limit_order_utils__WEBPACK_IMPORTED_MODULE_1__/* .orderTokenInfosByUiQuote */ .bS)([
        baseToken,
        quoteToken
    ], [
        tokenA,
        tokenB
    ]);
};
const getQueryKeyTickers = (tokenA, tokenB, span)=>{
    return [
        "tickers",
        [
            tokenA === null || tokenA === void 0 ? void 0 : tokenA.symbol,
            tokenB === null || tokenB === void 0 ? void 0 : tokenB.symbol
        ].sort().join(),
        span
    ];
};
const getQueryOptionsTickers = (spanInSeconds)=>({
        cacheTime: Infinity,
        staleTime: spanInSeconds * 1000
    });


/***/ }),

/***/ 38247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50594);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99226);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93946);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26447);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_chart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95060);
/* harmony import */ var _components_chart_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80021);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74069);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73680);











const CandleChartBox = (param)=>{
    let { tokenIn , tokenOut , onCandleListUpdated , onPriceSentFromSocket , onHideChart  } = param;
    const trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const [base, quote] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>tokenIn && tokenOut ? (0,_components_chart_utils__WEBPACK_IMPORTED_MODULE_3__/* .orderTokensLikeBE */ .gO)(tokenIn, tokenOut) : [
            undefined,
            undefined
        ], [
        tokenIn,
        tokenOut
    ]);
    const [timeFrame, setTimeFrame] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("one_hour");
    if (!base || !quote) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var _base_displaySymbol, _quote_displaySymbol, _base_displaySymbol1, _quote_displaySymbol1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: "bg-[#1E2735] rounded-t-3xl sm:rounded-b-3xl pb-[100%] lg:pb-0 relative",
        "data-testid": "chart",
        width: {
            xs: "100%",
            lg: "55%"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "absolute inset-0 py-6 pl-6 pr-4 max-h-[50vh]",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: -1,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "data-testid": "chart-token-in-logo",
                                            src: base.logoURI || _utils_helpers__WEBPACK_IMPORTED_MODULE_5__/* .NOT_AVAILABLE_LOGO_URL */ .Ov,
                                            alt: (_base_displaySymbol = base.displaySymbol) !== null && _base_displaySymbol !== void 0 ? _base_displaySymbol : "Unknown",
                                            className: "rounded-full w-6 h-6"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "data-testid": "chart-token-out-logo",
                                            src: quote.logoURI || _utils_helpers__WEBPACK_IMPORTED_MODULE_5__/* .NOT_AVAILABLE_LOGO_URL */ .Ov,
                                            alt: (_quote_displaySymbol = quote.displaySymbol) !== null && _quote_displaySymbol !== void 0 ? _quote_displaySymbol : "Unknown",
                                            className: "rounded-full w-6 h-6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    className: "text-sm font-semibold",
                                    "data-testid": "chart-token-pair",
                                    children: [
                                        (_base_displaySymbol1 = base.displaySymbol) !== null && _base_displaySymbol1 !== void 0 ? _base_displaySymbol1 : "Unknown",
                                        "/",
                                        (_quote_displaySymbol1 = quote.displaySymbol) !== null && _quote_displaySymbol1 !== void 0 ? _quote_displaySymbol1 : "Unknown"
                                    ]
                                })
                            ]
                        }),
                        onHideChart && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            "data-testid": "chart-close-btn",
                            onClick: onHideChart,
                            title: trans.limit.hide_chart_btn,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                fontSize: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: "flex-grow",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_chart__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        timeFrame: timeFrame,
                        tokenA: base,
                        tokenB: quote,
                        onCandleListUpdated: onCandleListUpdated,
                        onPriceSentFromSocket: onPriceSentFromSocket,
                        onTimeFrameChange: setTimeFrame
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CandleChartBox);


/***/ }),

/***/ 89010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73680);
/* harmony import */ var _wallet_adapter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33618);



const isCommitment = (value)=>typeof value === "string";
const useConfirmTransaction = ()=>{
    const { connection  } = (0,_wallet_adapter__WEBPACK_IMPORTED_MODULE_2__/* .useConnection */ .Rc)();
    const confirmTransaction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(txSignature) {
        let commitmentOrLatestBlockhash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "finalized";
        const latestBlockhash = isCommitment(commitmentOrLatestBlockhash) ? await connection.getLatestBlockhash(commitmentOrLatestBlockhash) : commitmentOrLatestBlockhash;
        const [, confirmation] = await (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__/* .toResultAsync */ .zM)(connection.confirmTransaction({
            signature: txSignature,
            ...latestBlockhash
        }));
        const error = !confirmation || confirmation.value.err;
        return [
            error,
            confirmation
        ];
    }, [
        connection
    ]);
    return {
        confirmTransaction
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useConfirmTransaction);


/***/ }),

/***/ 76243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_safely_send_tx_with_notice; }
});

// UNUSED EXPORTS: isKnownError

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
// EXTERNAL MODULE: ./src/wallet/adapter.ts + 1 modules
var adapter = __webpack_require__(33618);
// EXTERNAL MODULE: ./src/hooks/use-confirmation-transaction.ts
var use_confirmation_transaction = __webpack_require__(89010);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js + 3 modules
var index_browser_esm = __webpack_require__(27632);
;// CONCATENATED MODULE: ./src/hooks/use-gasless-handling.ts




const useGaslessHandling = ()=>{
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { wallet , publicKey  } = (0,adapter/* useWallet */.Os)();
    return (0,react.useCallback)(async (tx)=>{
        if ((0,constants/* isChainSolana */.j2)()) return await tx.buildAndExecute();
        const { instructions , cleanupInstructions , signers  } = tx.compressIx(true);
        const transaction = new index_browser_esm.Transaction();
        for (const ix of instructions){
            transaction.add(ix);
        }
        for (const cIx of cleanupInstructions){
            transaction.add(cIx);
        }
        transaction.feePayer = publicKey !== null && publicKey !== void 0 ? publicKey : undefined;
        transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
        for (const s of signers){
            transaction.sign(s);
        }
        return await (wallet === null || wallet === void 0 ? void 0 : wallet.adapter).sendTransactionWithSigners(transaction, connection, signers);
    }, [
        connection,
        wallet,
        publicKey
    ]);
};
/* harmony default export */ var use_gasless_handling = (useGaslessHandling);

// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./src/hooks/use-toast-message.tsx + 1 modules
var use_toast_message = __webpack_require__(36625);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 2 modules
var useTrans = __webpack_require__(74069);
;// CONCATENATED MODULE: ./src/hooks/use-safely-send-tx-with-notice.tsx











const KnownErrorTesters = {
    "0x1": [
        /Attempt to debit an account but found no record of a prior credit/,
        /custom program error: 0x1$/
    ],
    "wallet_refused": [
        /^refuse_send_transaction$/,
        /^user denied transaction signature$/,
        /^user denied sign transactions$/,
        /^WalletSignTransactionError$/,
        /^WalletSignTransactionError: Transaction rejected$/,
        /^WalletSignTransactionError: User rejected the request\.$/
    ]
};
const isKnownError = (error)=>{
    var _Object_entries_find;
    return (_Object_entries_find = Object.entries(KnownErrorTesters).find((param)=>{
        let [, testers] = param;
        return testers.some((tester)=>tester.test(error.message) || tester.test(String(error)));
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[0];
};
const useSafelySendTxWithNotice = function() {
    let globalContextOrOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const globalOptions = (0,react.useMemo)(()=>typeof globalContextOrOptions === "string" ? {
            context: globalContextOrOptions
        } : globalContextOrOptions, [
        globalContextOrOptions
    ]);
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { confirmTransaction  } = (0,use_confirmation_transaction/* default */.Z)();
    const { showMessage , showLoadingNotice  } = (0,use_toast_message/* default */.Z)();
    const trans = (0,useTrans/* default */.Z)();
    const { data: settingsData  } = (0,use_settings/* useSettings */.r)();
    const gaslessEnabled = Boolean(settingsData === null || settingsData === void 0 ? void 0 : settingsData.is_gasless_mode_enabled);
    const sendTxWithGasless = use_gasless_handling();
    var _globalOptions_alwaysHideTxExplorerLink, _globalOptions_confirmationErrorMessage, _globalOptions_confirmationErrorTitle, _ref, _globalOptions_context, _globalOptions_errorMessage, _globalOptions_errorTitle, _globalOptions_gasless, _globalOptions_onBeforeShowingNotice, _globalOptions_successMessage, _globalOptions_successTitle, _globalOptions_throwOnError, _globalOptions_waitUntilConfirmed;
    const safelySendTxWithNotice = (0,react.useCallback)(/**
     * @throws never, unless `throwOnError` is set to `true`.
     */ async function(tx) {
        let { alwaysHideTxExplorerLink =(_globalOptions_alwaysHideTxExplorerLink = globalOptions.alwaysHideTxExplorerLink) !== null && _globalOptions_alwaysHideTxExplorerLink !== void 0 ? _globalOptions_alwaysHideTxExplorerLink : false , confirmationErrorMessage =(_globalOptions_confirmationErrorMessage = globalOptions.confirmationErrorMessage) !== null && _globalOptions_confirmationErrorMessage !== void 0 ? _globalOptions_confirmationErrorMessage : trans.common.tx_notice.unconfirmed_message , confirmationErrorTitle =(_ref = (_globalOptions_confirmationErrorTitle = globalOptions.confirmationErrorTitle) !== null && _globalOptions_confirmationErrorTitle !== void 0 ? _globalOptions_confirmationErrorTitle : globalOptions.errorTitle) !== null && _ref !== void 0 ? _ref : trans.common.tx_notice.error_title , context =(_globalOptions_context = globalOptions.context) !== null && _globalOptions_context !== void 0 ? _globalOptions_context : "common" , errorMessage =(_globalOptions_errorMessage = globalOptions.errorMessage) !== null && _globalOptions_errorMessage !== void 0 ? _globalOptions_errorMessage : trans.common.tx_notice.error_message , errorTitle =(_globalOptions_errorTitle = globalOptions.errorTitle) !== null && _globalOptions_errorTitle !== void 0 ? _globalOptions_errorTitle : trans.common.tx_notice.error_title , gasless =(_globalOptions_gasless = globalOptions.gasless) !== null && _globalOptions_gasless !== void 0 ? _globalOptions_gasless : gaslessEnabled , onBeforeShowingNotice =(_globalOptions_onBeforeShowingNotice = globalOptions.onBeforeShowingNotice) !== null && _globalOptions_onBeforeShowingNotice !== void 0 ? _globalOptions_onBeforeShowingNotice : ()=>true , primaryButton =globalOptions.primaryButton , snackbarOptions =globalOptions.snackbarOptions , successMessage =(_globalOptions_successMessage = globalOptions.successMessage) !== null && _globalOptions_successMessage !== void 0 ? _globalOptions_successMessage : trans.common.tx_notice.success_message , successTitle =(_globalOptions_successTitle = globalOptions.successTitle) !== null && _globalOptions_successTitle !== void 0 ? _globalOptions_successTitle : trans.common.tx_notice.success_title , throwOnError =(_globalOptions_throwOnError = globalOptions.throwOnError) !== null && _globalOptions_throwOnError !== void 0 ? _globalOptions_throwOnError : false , titleAppendix =globalOptions.titleAppendix , waitUntilConfirmed =(_globalOptions_waitUntilConfirmed = globalOptions.waitUntilConfirmed) !== null && _globalOptions_waitUntilConfirmed !== void 0 ? _globalOptions_waitUntilConfirmed : true  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const noticeElement = function(e) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return typeof e === "function" ? e(...args) : e;
        };
        const [error, signature] = await (0,helpers/* toResultAsync */.zM)("then" in tx ? tx : gasless && !(0,constants/* isChainSolana */.j2)() ? sendTxWithGasless(tx) : tx.buildAndExecute());
        if (error) {
            var _isKnownError;
            const errorKey = (_isKnownError = isKnownError(error)) !== null && _isKnownError !== void 0 ? _isKnownError : "unknown";
            const errorTroubleshootingByContext = trans.common.tx_notice.errors[errorKey];
            var _errorTroubleshootingByContext_common;
            const troubleshooting = [
                ...(_errorTroubleshootingByContext_common = errorTroubleshootingByContext === null || errorTroubleshootingByContext === void 0 ? void 0 : errorTroubleshootingByContext.common) !== null && _errorTroubleshootingByContext_common !== void 0 ? _errorTroubleshootingByContext_common : []
            ];
            if (context !== "common" && (errorTroubleshootingByContext === null || errorTroubleshootingByContext === void 0 ? void 0 : errorTroubleshootingByContext[context])) {
                troubleshooting.splice(0, 0, ...errorTroubleshootingByContext[context]);
            }
            // eslint-disable-next-line no-console
            console.error("".concat(context, " send transaction error"), error, error.logs);
            if (onBeforeShowingNotice("error", error) !== false) {
                showMessage({
                    error,
                    message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm",
                                children: noticeElement(errorMessage, error)
                            }),
                            Boolean(troubleshooting.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-xs font-bold",
                                        children: trans.common.tx_notice.what_should_i_do_now
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        spacing: 0.5,
                                        children: troubleshooting.map((solution, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "li",
                                                className: "text-sm",
                                                children: solution
                                            }, index))
                                    })
                                ]
                            })
                        ]
                    }),
                    primaryButton: noticeElement(primaryButton, "error", error),
                    title: noticeElement(errorTitle, error),
                    titleAppendix: noticeElement(titleAppendix, "error", error),
                    type: "error"
                }, snackbarOptions);
            }
            if (throwOnError) throw error;
            return;
        }
        if (waitUntilConfirmed) {
            const latestBlockhash = await connection.getLatestBlockhash();
            const closeLoadingNotice = showLoadingNotice({
                lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
                signature
            });
            const [isTxConfirmed, { value: { err: confirmationError  }  }] = await confirmTransaction(signature, latestBlockhash);
            closeLoadingNotice();
            if (!isTxConfirmed && confirmationError) {
                // eslint-disable-next-line no-console
                console.error("".concat(context, " confirm transaction error"), confirmationError);
                if (onBeforeShowingNotice("confirmation_error", signature, confirmationError) !== false) {
                    showMessage({
                        message: noticeElement(confirmationErrorMessage, signature, error),
                        primaryButton: noticeElement(primaryButton, "confirmation_error", signature, error),
                        title: noticeElement(confirmationErrorTitle, signature, error),
                        titleAppendix: noticeElement(titleAppendix, "confirmation_error", signature, error),
                        type: "error",
                        txid: alwaysHideTxExplorerLink ? undefined : signature
                    }, snackbarOptions);
                }
                if (throwOnError) throw confirmationError;
                return;
            }
        }
        ;
        if (onBeforeShowingNotice("success", signature) !== false) {
            showMessage({
                message: noticeElement(successMessage, signature),
                primaryButton: noticeElement(primaryButton, "success", signature),
                title: noticeElement(successTitle, signature),
                titleAppendix: noticeElement(titleAppendix, "success", signature),
                type: "success",
                txid: alwaysHideTxExplorerLink ? undefined : signature
            }, snackbarOptions);
        }
        return signature;
    }, [
        confirmTransaction,
        connection,
        gaslessEnabled,
        globalOptions,
        sendTxWithGasless,
        showLoadingNotice,
        showMessage,
        trans
    ]);
    return {
        safelySendTxWithNotice
    };
};
/* harmony default export */ var use_safely_send_tx_with_notice = (useSafelySendTxWithNotice);


/***/ }),

/***/ 86447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ch": function() { return /* binding */ getTickers; },
  "Dg": function() { return /* binding */ secondsToTickerTimeFrame; },
  "zI": function() { return /* binding */ tickerTimeFrameToSeconds; }
});

// UNUSED EXPORTS: ONE_DAY_IN_SEC

;// CONCATENATED MODULE: ./src/utils/dict.ts
/**
 * An {@link Object} that prefills default value for non-existing entries when
 * getting.
 */ const dict = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return new Proxy({}, {
        get (target, p, receiver) {
            if (!Reflect.has(target, p) && args.length) {
                Reflect.set(target, p, args[0], receiver);
            }
            return Reflect.get(target, p, receiver);
        }
    });
};
/* harmony default export */ var utils_dict = (dict);

// EXTERNAL MODULE: ./src/utils/apis/index.ts
var apis = __webpack_require__(40795);
;// CONCATENATED MODULE: ./src/utils/apis/tickers.ts


const ONE_MINUTE_IN_SEC = 60;
const ONE_HOUR_IN_SEC = 60 * ONE_MINUTE_IN_SEC;
const ONE_DAY_IN_SEC = 24 * ONE_HOUR_IN_SEC;
const tickerTimeFrameToSeconds = Object.assign(utils_dict(ONE_DAY_IN_SEC), {
    one_minute: ONE_MINUTE_IN_SEC,
    five_minutes: 5 * ONE_MINUTE_IN_SEC,
    fifteen_minutes: 15 * ONE_MINUTE_IN_SEC,
    thirty_minutes: 30 * ONE_MINUTE_IN_SEC,
    one_hour: 1 * ONE_HOUR_IN_SEC,
    four_hours: 4 * ONE_HOUR_IN_SEC,
    twenty_four_hour: 24 * ONE_HOUR_IN_SEC,
    one_week: 1 * 7 * ONE_DAY_IN_SEC,
    one_month: 1 * 30 * ONE_DAY_IN_SEC
});
const secondsToTickerTimeFrame = Object.assign(utils_dict("twenty_four_hour"), Object.fromEntries(Object.entries(tickerTimeFrameToSeconds).map((param)=>{
    let [key, value] = param;
    return [
        value,
        key
    ];
})));
const getTickers = async function(tokenA, tokenB) {
    let timeFrame = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "twenty_four_hour", startTime = arguments.length > 3 ? arguments[3] : void 0;
    const { data  } = await apis/* api.get */.h.get("/tickers/trading_view", {
        params: {
            token0: tokenA.symbol,
            token1: tokenB.symbol,
            time_frame: timeFrame,
            start_time: startTime
        }
    });
    const candles = data.klines.map((kline)=>({
            open: kline.o,
            close: kline.c,
            low: kline.l,
            high: kline.h,
            span: tickerTimeFrameToSeconds[timeFrame],
            startTime: new Date(kline.t),
            volume: kline.v
        })).sort((a, b)=>a.startTime.getTime() - b.startTime.getTime());
    const [token0] = data.pair.split("/");
    const isTokenA0 = tokenA.symbol.toLowerCase() === token0;
    return {
        tokenA: isTokenA0 ? tokenA : tokenB,
        tokenB: isTokenA0 ? tokenB : tokenA,
        candles
    };
};


/***/ })

}]);